import styled from "@emotion/styled";

const StyledSizeGuide = styled.div`
  max-width: 600px;
  color: ${({ theme }) => theme.colors.tone.black};
  letter-spacing: 0.05em;
  background: ${({ theme }) => theme.colors.tone.white};

  .SizeGuide__header {
    position: relative;
    height: 70px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 15px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.tone.anthraciteDark};
    letter-spacing: 0.2em;
    font-weight: 600;
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.primary.platinumLight};
  }

  .SizeGuide__close {
    position: absolute;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
    padding: 0;
    width: 16px;
    height: 16px;
  }

  .SizeGuide__content {
    padding: 24px;
    height: calc(100vh - 70px);
    overflow: auto;
  }

  .SizeGuide__tableContainer {
    width: 100%;
    overflow: auto;
  }

  table {
    width: 100% !important;
    border: 0;

    border-collapse: collapse;
    border-spacing: 0;
  }

  h3 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
  }

  h4 {
    font-size: 14px;
    text-transform: uppercase;
    padding: 10px;
    margin: 0 0 10px;
    text-align: center;
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.primary.platinumLight};
  }

  .size-chart-row {
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.primary.platinumLight};
  }

  .size-chart-table {
    max-width: 500px;
    width: 100%;
    margin: 0 auto 20px;
    padding: 0 15px;
    letter-spacing: 0.05em;
  }

  tr {
    padding: 0;
    margin: 0;
  }

  th {
    text-transform: uppercase;
    font-weight: 400;

    font-size: 14px;
    padding: 5px 10px;
    border: 1px solid ${({ theme }) => theme.colors.tone.silver};
  }

  td {
    margin: 0;
    font-size: 14px;
    padding: 5px 10px;
    border: 1px solid ${({ theme }) => theme.colors.tone.silver};
    color: ${({ theme }) => theme.colors.tone.anthraciteLight};
  }
`;

export { StyledSizeGuide };
